import { useMemo } from 'react';
import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useRankingsChartsDataContext } from './hooks/useRankingsChartsDataContext';

export const ByObjectType = () => {
    const { chartData } = useRankingsChartsDataContext();

    const { subtitles, values } = useMemo(() => {
        const items = (chartData?.byObjectType || [])
            .slice()
            .sort((a, b) => Number(b.total) - Number(a.total))
            .slice(0, 10);

        return {
            subtitles: items.map(
                (item) => item.desc_tipo_objeto || 'Não informado'
            ),
            values: items.map(
                (item) => Number(item.total)
            )
        };
    }, [chartData]);

    return (
        <SimpleBars
            title="Ranking por Tipo de Objeto"
            horizontal
            subtitles={subtitles}
            values={values}
            height={420}
            showDataLabels
        />
    );
};